module.exports = __webpack_public_path__ + "411a6bdcf937822ee104f040b36d7fbe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C0000516O.png
// module id = 1680
// module chunks = 0